import { useEffect } from 'react'
import { Row, Card } from 'antd'
import { GlobalHeader, GlobalFooter } from './components'

import UnsubscribeStyle from '../../styles/Unsubscribe.module.css'

var subtitle = 'We\'re sorry'
var message = <>A technical issue has occurred. Please try again later or call <a href="tel:+1800-535-2873">800-535-CURE</a> if this problem persists.</>

const Unsubscribe = () => {
  useEffect(() => {
    const url = new URL(window.location.href)
    const success = url.searchParams.get('success')
    if (success == 1) {
      subtitle = 'Thank you'
      message = <>You have been successfully removed from our marketing email list and won't receive any further marketing emails from us.</>
    }
  }, [])

  return (
    <>
      <GlobalHeader />
      <div className={`${UnsubscribeStyle["unsubscribe-container"]}`}>
        <div className={`${UnsubscribeStyle["unsubscribe-container"]}`}>
          <Row justify="center">
            <Card className={`${UnsubscribeStyle["unsubscribe-card"]}`}>
              <Row>
                <h2 className={`${UnsubscribeStyle["unsubscribe-title"]}`}>
                  Unsubscribe
                </h2>
              </Row>
              <hr />
              <span className={`${UnsubscribeStyle["sub-text"]}`}>{subtitle}</span>
              <p>
                {message}
              </p>
            </Card>
          </Row>
        </div>
      </div>
      <GlobalFooter />
    </>
  )
}

Unsubscribe.propTypes = {}

export default Unsubscribe
